import React from 'react';
import PropTypes from 'prop-types';
import Price from 'components/Price';

const PriceTypeOption = props => {
    return (
        <div className="syos-pricetype-unit">
            <span className="syos-pricetype-unit__details">
                <Price priceData={props.priceType} isStacked={true} />
            </span>
            <span className="syos-pricetype-unit__action">
                <button className="syos-button" onClick={props.handleSelection}>Select</button>
            </span>
        </div>
    );
}
PriceTypeOption.propTypes = {
    handleSelection: PropTypes.func,
    priceType: PropTypes.shape({
        price_type_desc: PropTypes.string,
        price: PropTypes.string
    })
};

export default PriceTypeOption;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/PriceTypeOption.js